import { connect } from "react-redux";
import BookCard from "./components";
import { addBookToCart, playAudio,playAll } from "../../../actions";
import { redirectToBook, uniqBy } from "../../../common/util";

const mapDispatchToProps = (dispatch) => ({
  addBookToCart: (book) => dispatch(addBookToCart(book)),
  playAudio: (track) => {
    dispatch(playAudio(track));
  },
  playAll: (tracks) => {
    dispatch(playAll(tracks));
  },
});

const mapStateToProps = () => ({
  redirect: redirectToBook,
});

export default connect(mapStateToProps, mapDispatchToProps)(BookCard);
